import { Link } from 'react-router-dom';

export function Impressum() {
  return (
    <div className="mt-[70px]">
      <section className="relative pt-16 pb-10 text-center border-b border-white/[0.06] overflow-hidden">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[400px] h-[400px] rounded-full bg-gold/[0.04] blur-3xl pointer-events-none" />
        <div className="relative z-10 max-w-2xl mx-auto px-6">
          <h1 className="font-display text-4xl md:text-5xl font-bold italic text-glow mb-3">
            Im<span className="text-gold">pressum</span>
          </h1>
          <p className="text-text-muted">Angaben gemäß § 5 TMG und § 55 RStV</p>
        </div>
      </section>

      <div className="max-w-[800px] mx-auto px-6 py-12">
        <div className="space-y-6">
          <div className="bg-surface rounded-2xl border border-white/[0.06] p-6 hover:border-gold/25 transition-all">
            <h2 className="flex items-center gap-3 text-lg font-bold text-gold mb-4">
              <span className="w-1 h-6 bg-gold rounded-full" />
              Anbieteridentifikation
            </h2>
            <ul className="space-y-2 text-text-secondary text-sm">
              <li><strong className="text-text-primary">Name:</strong> Joachim Leiskau</li>
              <li><strong className="text-text-primary">Adresse:</strong> Alkesis-Kivi-Str. 2, 18016 Rostock, Deutschland</li>
              <li><strong className="text-text-primary">E-Mail:</strong> <a href="mailto:JL-Software@gmx.de" className="text-gold hover:underline">JL-Software@gmx.de</a></li>
            </ul>
            <p className="text-text-secondary text-sm mt-4">
              <strong className="text-text-primary">Hinweis:</strong> Dies ist ein rein privates Einzelunternehmen im Sinne des § 5 TMG. Es besteht keine Eintragung in ein Handelsregister (keine GmbH, UG, GbR oder ähnliche Rechtsform). Eine Umsatzsteuer-Identifikationsnummer wird aktuell nicht geführt.
            </p>
          </div>

          <div className="bg-surface rounded-2xl border border-white/[0.06] p-6 hover:border-gold/25 transition-all">
            <h2 className="flex items-center gap-3 text-lg font-bold text-gold mb-4">
              <span className="w-1 h-6 bg-gold rounded-full" />
              Haftungsausschluss
            </h2>
            <div className="space-y-3 text-text-secondary text-sm leading-relaxed">
              <p>
                <strong className="text-text-primary">Haftung für Inhalte:</strong> Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen.
              </p>
              <p>
                <strong className="text-text-primary">Haftung für Links:</strong> Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen.
              </p>
            </div>
          </div>

          <div className="bg-surface rounded-2xl border border-white/[0.06] p-6 hover:border-gold/25 transition-all">
            <h2 className="flex items-center gap-3 text-lg font-bold text-gold mb-4">
              <span className="w-1 h-6 bg-gold rounded-full" />
              Urheberrecht
            </h2>
            <p className="text-text-secondary text-sm leading-relaxed">
              Die durch den Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
            </p>
          </div>

          <div className="bg-surface rounded-2xl border border-white/[0.06] p-6 hover:border-gold/25 transition-all">
            <h2 className="flex items-center gap-3 text-lg font-bold text-gold mb-4">
              <span className="w-1 h-6 bg-gold rounded-full" />
              Datenschutz
            </h2>
            <p className="text-text-secondary text-sm leading-relaxed">
              Der Schutz Ihrer persönlichen Daten ist uns ein besonderes Anliegen. Wir verarbeiten Ihre Daten daher ausschließlich auf Grundlage der gesetzlichen Bestimmungen (DSGVO, TMG). Details entnehmen Sie bitte unserer separaten <Link to="/datenschutz" className="text-gold hover:underline">Datenschutzerklärung</Link>.
            </p>
          </div>
        </div>

        <Link to="/" className="inline-flex items-center gap-2 mt-8 text-text-muted hover:text-gold transition-colors text-sm font-medium">
          ← Zurück zur Startseite
        </Link>
      </div>
    </div>
  );
}
